import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-4 mr-4"
}

import { computed } from "vue";
import { useStore } from "vuex";
import TwLabel from "../TwLabel.vue";
import TwTextarea from "../TwTextarea.vue";
import TwButtonsYesAndNo from "../TwButtonsYesAndNo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: '1.HadFacial',
  setup(__props) {

const store = useStore();

const hadFacialBefore = computed(() => store.state.form.had_facial_before);
const hadFacialBeforeWhen = computed({
  get: () => store.state.form.had_facial_before_when,
  set: (value) => store.dispatch("updateHadFacialBeforeWhen", value),
});
const hadFacialBeforeHowOften = computed({
  get: () => store.state.form.had_facial_before_how_often,
  set: (value) => store.dispatch("updateHadFacialBeforeHowOften", value),
});

const updateHadFacialBefore = (value: boolean) => {
  store.dispatch("updateHadFacialBefore", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[hadFacialBefore.value == null ? 'bg-red-500' : ''], "p-2"])
  }, [
    _createVNode(TwLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("had_facial_before")), 1)
      ]),
      _: 1
    }),
    _createVNode(TwButtonsYesAndNo, {
      isActive: hadFacialBefore.value,
      onOnClickYes: _cache[0] || (_cache[0] = ($event: any) => (updateHadFacialBefore(true))),
      onOnClickNo: _cache[1] || (_cache[1] = ($event: any) => (updateHadFacialBefore(false)))
    }, null, 8, ["isActive"]),
    (hadFacialBefore.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(TwLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("when")), 1)
            ]),
            _: 1
          }),
          _createVNode(TwTextarea, {
            modelValue: hadFacialBeforeWhen.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((hadFacialBeforeWhen).value = $event)),
            rows: 1,
            id: "hadFacialBeforeWhen"
          }, null, 8, ["modelValue"]),
          _createVNode(TwLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("how_often")), 1)
            ]),
            _: 1
          }),
          _createVNode(TwTextarea, {
            modelValue: hadFacialBeforeHowOften.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((hadFacialBeforeHowOften).value = $event)),
            rows: 1,
            id: "hadFacialBeforeHowOften"
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})